import { mapEventType } from '../../helper/map-event-type';
export const eventKey = (config, _data, globalConfig) => {
  return {
    'event:key': `${globalConfig.product}.fe.${mapEventType(config.type)}.${config.key}`
  };
};